import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { semanticColors } from '../../Globals/styles';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import Workplace from './workplace';
import { showSidebarConst, departmentColumns } from '../../Globals/constants';


class GatheredColumns extends Component {
  renderSingleColumn = (title, workplaceIds, columnIndex) => {
    const { params, showSidebar } = this.props;

    let workplaceNodes = []
    workplaceIds.forEach((workplaceId, index) => {

      workplaceNodes.push(
        <div key={workplaceId} style={styles.workplaceContainer}>
          <Workplace
            key={workplaceId}
            workplaceId={workplaceId}
            params={params}
            position={{ columnIndex: columnIndex, index: index }}
            showSidebar={showSidebar}
          />
        </div>
      )
    })

    return (
      <div key={columnIndex}>
        <h2 style={styles.h2}>{title}</h2>
        {
          workplaceNodes
        }
      </div>
    );
  };
  render() {
    const { columnsShowing, organizer, pageForInvoice, paginationCountPerPage } = this.props;
    let columnNodes = [];
    organizer.forEach((singleOrganizer, index) => {
      if (index >= columnsShowing.from && index <= columnsShowing.to) {
        columnNodes.push(
          this.renderSingleColumn(
            departmentColumns[index],
            index === organizer.length - 1 ? singleOrganizer.items.slice(0, pageForInvoice * paginationCountPerPage) : singleOrganizer.items,
            index)
        )
      }
    })
    return (
      <div style={styles.column}>
        <Scrollbars style={{ width: '100%', height: '100%' }}>
          {columnNodes}
        </Scrollbars>
      </div>
    )
  }
}

var styles = {
  column: {
    position: 'relative',
    backgroundColor: semanticColors.default,
    textAlign: 'center',
    height: '100%',
    borderRadius: '2px',
    boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    padding: '60px 10px 10px 10px'
  },
  h2: {
    backgroundColor: semanticColors.default,
    fontWeight: 'bold',
    height: '35px',
    lineHeight: '35px',
    width: '100%',
    borderRadius: '2px'
  },
  workplaceContainer: {
    position: 'relative',
    marginBottom: '12px'
  }
}
GatheredColumns.propTypes = {
  organizer: PropTypes.array.isRequired,
  showSidebar: PropTypes.oneOf(Object.keys(showSidebarConst)),
  workplaces: PropTypes.object,
  columnsShowing: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired
  }).isRequired,
  pageForInvoice: PropTypes.number.isRequired,
  paginationCountPerPage: PropTypes.number.isRequired
};
export default Radium(GatheredColumns)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/gatheredColumns.jsx